export default "__VITE_ASSET__6vF1M5zX__"